import { gql } from 'apollo-angular';

export default gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      success
      message
      username
    }
  }
`;
